export default {
  path: '/wecode/hardware-detail',
  auth: false,
  preload: false,
  key: 'new-hardware-detail',
  component: () => import('./index')
};
